import { ActionTypes, ReduxAction } from './types';
import { Dispatch } from 'redux';
import { MetrokennungService } from '../../api';

export const getMetrokennungen =
  () => async (dispatch: Dispatch<ReduxAction>) => {
    new MetrokennungService().getMetrokennungen().then(result => {
      dispatch({
        type: ActionTypes.GET_METROKENNUNGEN,
        payload: result.data,
      });
    });
  };
